<template>
    <div>
        <vx-card title="Leave Balance" subtitle="Lists of Leave Balance"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewLeaveBalance()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="getEmployeeLeaveBalance">
                    <template slot="thead">
                        <vs-th>Leave Type</vs-th>
                        <vs-th>Days</vs-th>
                        <vs-th>Hours</vs-th>
                        <vs-th>From Date</vs-th>
                        <vs-th>To Date</vs-th>
                        <vs-th>Date Credited</vs-th>
                        <vs-th>For Year</vs-th>
                        <vs-th>Tenure</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].leaveTypeId">
                                {{ leaveType(data[indextr].leaveTypeId).leaveTypeName }}
                            </vs-td>
                            <vs-td :data="data[indextr].leaveDays">
                                {{ data[indextr].leaveDays }}
                            </vs-td>
                            <vs-td :data="data[indextr].leaveHours">
                                {{ data[indextr].leaveHours }}
                            </vs-td>
                            <vs-td :data="data[indextr].startDate">
                                {{ data[indextr].startDate | fulldate }}
                            </vs-td>
                            <vs-td :data="data[indextr].endDate">
                                {{ data[indextr].endDate | fulldate }}
                            </vs-td>
                             <vs-td :data="data[indextr].dateCredited">
                                {{ data[indextr].dateCredited | fulldate}} 
                            </vs-td>
                            <vs-td :data="data[indextr].forYear">
                                {{ data[indextr].forYear }}
                            </vs-td>
                            <vs-td :data="data[indextr].tenureId">
                                {{ data[indextr].tenureId }}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD LEAVE BALANCE -->
            <vs-prompt
                class="email-compose"
                title="Leave Balance"
                accept-text= "Submit"
                @accept="onAddLeaveBalance"
                :is-valid="validForm"
                :active.sync="activePromptNewLeaveBalance">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Type</span><span style="color:red">*</span>
                        <v-select name="leaveType-name" class="w-full" v-model="leaveTypeName" label="leaveTypeName" :options="getLeaveBenefits" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Days</span><span style="color:red">*</span>
                        <vs-input name="leave days" v-validate="'numeric|max_value:' + maxDays" class="w-full" v-model="employeeLeaveBalance.leaveDays" :disabled="employeeLeaveBalance.leaveTypeId != null ? false : true" />
                        <span class="text-danger text-sm" v-show="errors.has('leave days')">{{ errors.first('leave days') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Hours</span><span style="color:red">*</span>
                        <vs-input name="leave hours" v-validate="'numeric|max_value:' + maxDays * 8" class="w-full" v-model="employeeLeaveBalance.leaveHours" :disabled="employeeLeaveBalance.leaveTypeId != null ? false : true"   />
                        <span class="text-danger text-sm" v-show="errors.has('leave hours')">{{ errors.first('leave hours') }}</span>

                    </div>
                </div>
                
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">From</span> <span style="color:red">*</span>
                       <flat-pickr :config="configFromdateTimePicker" :format="format" name="startDate-name" class="w-full" v-model="employeeLeaveBalance.fromDate" placeholder="Select Date" @on-change="onFromChange" />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">To</span>
                        <flat-pickr :config="configTodateTimePicker" :format="format" name="endDate-name" class="w-full" v-model="employeeLeaveBalance.toDate" placeholder="Select Date" @on-change="onToChange"  />
                        
                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Credited</span><span style="color:red">*</span>
                        <datepicker name="dateCredited-name" class="w-full" v-model="employeeLeaveBalance.dateCredited" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">For Year</span><span style="color:red">*</span>
                        <v-select   class="w-full" name="year" v-model="employeeLeaveBalance.forYear" label="year" :options="getYearsLookup" placeholder="2021" />
                   </div>
                </div>
              </vx-card>
            </vs-prompt>




            <!-- EDIT LEAVE BALANCE -->
            <!-- <vs-prompt
                class="email-compose"
                title="Edit Leave Balance"
                accept-text= "Submit"
                @accept="onEditLeaveBalance"
                :is-valid="validForm"
                :active.sync="activePromptEditLeaveBalance">
                <vx-card title="You may update the following information">


               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Type</span><span style="color:red">*</span>
                        <v-select name="leaveType-name" class="w-full" v-model="leaveType" label="leaveTypeName" :options="getLeaveBenefits" placeholder="Please Select" />

                    </div>
                </div>
               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Days</span><span style="color:red">*</span>
                        <vs-input name="leave days" v-validate="'numeric|max_value:' + leaveTypeName.maxDays" class="w-full" v-model="leaveDays" :disabled="employeeLeaveBalance.leaveTypeId != null ? false : true" />
                        <span class="text-danger text-sm" v-show="errors.has('leave days')">{{ errors.first('leave days') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Hours</span><span style="color:red">*</span>
                        <vs-input name="leave hours" v-validate="'numeric|max_value:' + leaveTypeName.maxDays * 8" class="w-full" v-model="leaveHours" :disabled="employeeLeaveBalance.leaveTypeId != null ? false : true"    />
                        <span class="text-danger text-sm" v-show="errors.has('leave hours')">{{ errors.first('leave hours') }}</span>

                    </div>
                </div>
                
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">From</span> <span style="color:red">*</span>
                       <flat-pickr :config="configFromdateTimePicker" name="startDate-name" class="w-full" v-model="startDate" placeholder="Select Date" @on-change="onFromChange" />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">To</span>
                        <flat-pickr :config="configTodateTimePicker" name="endDate-name" class="w-full" v-model="endDate" placeholder="Select Date" @on-change="onToChange"  />
                        
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Credited</span><span style="color:red">*</span>
                        <datepicker name="dateCredited-name" class="w-full" v-model="dateCredited" placeholder="Select Date"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">For Year</span><span style="color:red">*</span>
                        <v-select   class="w-full" name="year" v-model="forYear" label="year" :options="getYearsLookup" placeholder="2021" />
                   </div>
                </div>
                
               
                 
                 
            
                </vx-card>
            </vs-prompt>-->
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            employeeLeaveBalance: {
                leaveTypeId         : null,
                leaveDays           : 0,
                leaveHours          : 0,
                fromDate            : null,
                toDate              : null,
                forYear             : null,
                tenureId            : null,
                dateCredited        : null,
                userId              : null,
                carryOverExpiredOn: null,
                convertibleToCashExpiredOn: null,
                expiredOn: null,
                forfeitedExpiredOn: null,
                isCarryOver: false,
                isCarryOverExpired: false,
                isConvertibleToCash: false,
                isConvertibleToCashExpired: false,
                isExpired: false,
                isForForfeited: false,
                isForForfeitedExpired: false,
                isReserved: false,
                isReservedExpired: false,
                reservedExpiredOn: null,
                currentUserId       : null,
            },
           
            maxDays: 0,
            configFromdateTimePicker: {
              maxDate: null
            },
            configTodateTimePicker: {
              minDate: null
            },

            uId                 : null,
            activePromptNewLeaveBalance    : false,
            activePromptEditLeaveBalance    : false,

            format: "d MMMM yyyy",
            tenantsSettings: {},
        }
    },
    created() {
            this.$vs.loading()
            this.uId = this.$route.params.id
            this.$store.dispatch('lookup/getAllLeaveTypeLookup')
            
            this.$store.dispatch('hrms/getAllLeaveBenefits', this.uId)
                .then(res => { this.$vs.loading.close() })
                .catch(error => { 
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                        })
                })
            
            this.$store.dispatch('hrms/getAllLeaveBalance', this.uId)
 
            this.tenantsSettings =  JSON.parse(localStorage.getItem('tenantsSettings'))

    },
    computed: {
        getEmployeeLeaveBalance() {
            return this.$store.state.hrms.employeeLeaveBalance
        },
        getYearsLookup () {
            const year = new Date().getFullYear()
            return Array.from({length: year - 1900}, (value, index) => 1901 + index)
        },
        validForm(){
            return this.employeeLeaveBalance.leaveTypeId != null
        },
        getAllLeaveTypeLookup(){
            return this.$store.state.lookup.getAllLeaveTypes
        },
        getLeaveBenefits() {
            let eb = []
            for(var e =0; e < this.$store.state.hrms.employeeLeaveBenefits.length; e++ ) {
                eb.push(this.$store.state.hrms.employeeLeaveBenefits[e].leaveType)
            }
            return eb
        },
        leaveType() {
             return (leaveTypeId) => this.$store.getters['lookup/leaveTypeLookup'](leaveTypeId)
        },
        leaveTypeName: {
            get() { return this.$store.getters['lookup/leaveTypeLookup'](this.employeeLeaveBalance.leaveTypeId) },
            set(obj) { this.employeeLeaveBalance.leaveTypeId = obj.leaveTypeId}
        },
       
    },
    watch : {
        leaveTypeName () {
            this.maxDays = this.leaveTypeName.maxDays 
            
        },
        'employeeLeaveBalance.leaveDays'() {
            this.employeeLeaveBalance.leaveHours = this.employeeLeaveBalance.leaveDays * this.tenantsSettings.hoursInADay
        }
               
    },
    methods: {
        promptAddNewLeaveBalance() {
            
            this.activePromptNewLeaveBalance = true
        },
        onAddLeaveBalance() {
            this.$validator.validateAll().then(result => {
            if (result) {
                this.$vs.loading()

                this.employeeLeaveBalance.isCarryOver = this.leaveTypeName.isCarryOver
                this.employeeLeaveBalance.isConvertibleToCash = this.leaveTypeName.isConvertibleToCash
                this.employeeLeaveBalance.isForForfeited = this.leaveTypeName.isForfeited
                this.employeeLeaveBalance.isReserved = this.leaveTypeName.isReserved
                this.employeeLeaveBalance.userId = this.uId
                this.employeeLeaveBalance.currentUserId = this.$store.state.AppActiveUser.uid
                this.employeeLeaveBalance.tenureId = 1

                this.$store.dispatch('hrms/AddLeaveBalance', this.employeeLeaveBalance)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Leave Balance Saved',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
            } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        onEditLeaveBalance() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                  : this.id,
                    leaveTypeId         : this.employeeLeaveBalance.leaveTypeId,
                    leaveDays           : this.leaveDays,
                    leaveHours          : this.leaveHours,
                    startDate           : this.startDate,
                    endDate             : this.endDate,
                    forYear             : this.forYear,
                    dateCredited        : this.dateCredited,
                    tenureId            : this.tenureId,
                    userId              : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateLeaveBalance', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Leave Balance Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeLeaveBalance'](Id)
            this.id                = e.id,
            this.leaveType         = this.leaveTypeName(e.leaveTypeId),
            this.leaveDays         = e.leaveDays,
            this.leaveHours        = e.leaveHours,
            this.startDate         = e.startDate,
            this.endDate           = e.endDate,
            this.forYear           = e.forYear,
            this.dateCredited      = e.dateCredited,
            this.tenureId          = e.tenureId,
            this.userId            = e.userId

            this.activePromptEditLeaveBalance = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteLeaveBalance', id)
            .then(res => {
                this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Leave Balance Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        },
        onFromChange(selectedDates, dateStr, instance) {
            this.$set(this.configTodateTimePicker, 'minDate', dateStr);
        },
        onToChange(selectedDates, dateStr, instance) {
            this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>